import React, { Component } from 'react';
import AppLogo from './AppLogo';
import styled from 'styled-components';
import { Flex, Box } from 'grid-styled';

const Body = styled(Flex)`
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-align: center;
`;

const VerticalCenter = styled(Box)`
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 100%;
`;

class UnderConstruction extends Component {
  render() {
    return (
      <Body>
        <VerticalCenter>
          <AppLogo color="black" />
          <p>
            AmericanViolence.org is offline for scheduled maintenance. Check
            back soon.<br />
            Please direct all inquiries to{' '}
            <a href="mailto:info@americanviolence.org">
              info@americanviolence.org
            </a>.
          </p>
        </VerticalCenter>
      </Body>
    );
  }
}

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/components/UnderConstruction.jsx